import React, { useContext, useState, useEffect } from 'react'

import Session from '../context/SessionContext'
import { DataContext } from '../context/DataContext'

import { GroupedModules, getGroupedSimulationModules, getSimulationsView, TroubleshootingSimsViews } from '../Reporting'
import LoadingIndicator from './LoadingIndicator'
import TileView from './dataview/TileView'
import { TSModuleProfile } from '../interfaces/ModuleTypes'
import { PrimaryHeader } from '../styles/Styles'

const TroubleshootingSimulations: React.FC = () => {
    const { user } = useContext(Session)
    const { simProfiles } = useContext(DataContext)
    const [dataViews, setDataViews] = useState<TroubleshootingSimsViews>()

    useEffect(() => {
        if (!simProfiles) return

        const groupedSims: GroupedModules[] = getGroupedSimulationModules(simProfiles)
        const dataViews = {
            overall: getSimulationsView(simProfiles),
            groupedModules: groupedSims
        }
        setDataViews(dataViews)

    }, [simProfiles, user.companyId])


    if (!dataViews) return <LoadingIndicator loading={true} timeout={250} />
    return (
        <>
            <PrimaryHeader variant={'h4'}>
                {`Troubleshooting Simulations Data`}
            </PrimaryHeader>
            <TileView dataTiles={dataViews.overall} />
            {
                dataViews.groupedModules.map((sim, key) => <TileView key={'tstv' + key} title={sim.moduleName} dataTiles={getSimulationsView(sim.profiles as TSModuleProfile[])} />)
            }
        </>
    )
}

export default TroubleshootingSimulations


